/**
 * Event subtitle
 * 
 * @module event-subtitle
 * @version 1.0.0
 * @extends HTMLElement
 */
class eventSubtitle extends HTMLElement {

    /**
     * Event subtitle web component
     * 
     * @constructor
     */
    constructor() {

        super();

        const intersectionObserver = this.dataset.IntersectionObserver;

        if(intersectionObserver == 'true') {
            
            const handleIntersection = (entries, observer) => {

                if (!entries[0].isIntersecting) return;
    
                // init the component
                this.initSubtitle();
    
                // Stop observing the component
                observer.unobserve(this);
            }
    
            // Start observing the component
            new IntersectionObserver(handleIntersection.bind(this)).observe(this);
        }
        else {
            // init the component
            this.initSubtitle();
        }
    }

    /**
     * Init subtitle label
     * 
     * @return {undefined}
     */
    initSubtitle() {

        const handleEventName = this.dataset.eventName;

        // Check the event name
        if(handleEventName) {

            let event = window.shopEvents[handleEventName];

            if (typeof event != 'undefined') {

                this.setSubtitle(event);
            }
        }
    }

    /**
     * Set subtitle label
     * 
     * @param {Object} event Current event data.
     * @return {undefined}
     */
    setSubtitle(event) {

        const liveLabel = this.dataset.liveLabel;
        const comingSoonLabel = this.dataset.comingSoonDate;

        if(liveLabel == 'true') {

            if(event.status == 'live') {

                this.innerHTML = " ";

                if(event.start_date) {
                    let eventStartDate = new Date(event.start_date);

                    if(window.theme.shopifyDate) {

                        let shopifyCurrentDate = new Date(window.theme.shopifyDate.month + "/" + window.theme.shopifyDate.day + "/" + window.theme.shopifyDate.year);
                        let result = this.formatToDays(eventStartDate - shopifyCurrentDate);

                        if (result <= 0) {
                            this.classList.add("now-live");
                        } else {
                            if(comingSoonLabel == 'true') {
                                this.innerHTML = 'Opens ' + this.formatDateOnlyNumbers(event.start_date);
                                this.dataset.status= "opens";
                            }
                        }
                    }
                } 
        
                if(event.end_date) {

                    let eventEndDate = new Date(event.end_date);

                    if(window.theme.shopifyDate) {

                        let shopifyCurrentDate = new Date(window.theme.shopifyDate.month + "/" + window.theme.shopifyDate.day + "/" + window.theme.shopifyDate.year);
                        let result = this.formatToDays(eventEndDate - shopifyCurrentDate);

                        if(result <= 0) {
                            this.innerHTML = "Ends Today";
                            this.dataset.status= "ends";
                        }
                    }
                }
            }

            if (event.status == 'extended') {
                this.classList.add("now-live");
                this.dataset.status= "extended";
            }
        }
        
        if(event.status == 'coming-soon') {

            if(event.start_date) {
                let eventStartDate = new Date(event.start_date);
                let oneDayAfterEvent = new Date(eventStartDate);
                oneDayAfterEvent.setDate(oneDayAfterEvent.getDate() + 1);

                if(window.theme.shopifyDate) {

                    let shopifyCurrentDate = new Date(window.theme.shopifyDate.month + "/" + window.theme.shopifyDate.day + "/" + window.theme.shopifyDate.year);
                    let result = this.formatToDays(eventStartDate - shopifyCurrentDate);

                    if (result <= 0) {
                        this.classList.add("now-live");
                        this.insertAdjacentText("afterend", "Opens at 11AM EST");
                    } else {
                        if(result > 1 && result <= 3) {
                          const dayOfWeek = this.getDayOfWeek(eventStartDate);
                          const oneDayAfterDayOfWeek = this.getNextDayOfWeek(eventStartDate);

                          if (this.dataset.physicalEvent) {
                            this.innerHTML = '<span>Opens ' + dayOfWeek + '</span>';
                          } else {
                            this.innerHTML = '<span class="event-subtitle__msg">Opens ' + oneDayAfterDayOfWeek + '</span><span class="event-subtitle__msg members">Members Shop ' + dayOfWeek + '</span>';
                          }

                        } else {
                            if(comingSoonLabel == 'true') {
                                if (this.dataset.physicalEvent) {
                                    this.innerHTML = '<span>Opens ' + this.formatDateOnlyNumbers(event.start_date) + '</span>';
                                } else {
                                    this.innerHTML = '<span class="event-subtitle__msg">Opens ' + this.formatDateOnlyNumbers(oneDayAfterEvent) + '</span><span class="event-subtitle__msg members">Members Shop ' + this.formatDateOnlyNumbers(event.start_date) + '</span>';
                                }
                            }
                          else {
                              this.innerHTML = 'Opens ' + this.formatDateOnlyNumbers(event.start_date);
                          }
                        }
                    }
                }
            } 

        }
    }

    getDayOfWeek(date) {
      return Intl.DateTimeFormat(Shopify.locale, { weekday: 'long' }).format(date);
    }

    getNextDayOfWeek(date) {
        const nextDay = new Date(date);
        nextDay.setDate(date.getDate() + 1);
        return this.getDayOfWeek(nextDay);
    }

    /**
     * Transform to days
     * 
     * @param {Number} diffDates Difference between dates.
     * @return {Number}
     */
    formatToDays(diffDates) {
        var result = 0;

        if(diffDates) {
            result = diffDates / (24 * 60 * 60 * 1000);
        }
        
        return result;
    }

    /**
     * Format event date - 22nd February (example format)
     * 
     * @param {String} eventStartDate Current event data.
     * @return {String}
     */
    formatDate(eventStartDate) {

        if(eventStartDate) {

            let dateValue = new Date(eventStartDate);
           // let month = new Intl.DateTimeFormat(Shopify.locale, { month: 'long' }).format(dateValue);
            let day = new Intl.DateTimeFormat(Shopify.locale, { day: '2-digit' }).format(dateValue)


            eventStartDate = `${day}`;
        }

        return eventStartDate;
    }

    /**
     * Format event date - 02.22 (example format)
     * 
     * @param {String} eventStartDate Current event data.
     * @return {String}
     */
    formatDateOnlyNumbers(eventStartDate) {

        if(eventStartDate) {
            let date = new Date(eventStartDate);
            let month = date.getMonth() + 1;
            let day = date.getDate();

            let formattedMonth = month < 10 ? `${month}` : month;
            let formattedDay = day < 10 ? `${day}` : day;

            eventStartDate = `${formattedMonth}.${formattedDay}`;
        }

        return eventStartDate;
    }
}

customElements.define('event-subtitle', eventSubtitle);
